module.exports = __webpack_public_path__ + "static/media/bidmea-2.f157a913.png";